import { useState } from 'react';

export const AuthModel = () => {
  const [formData, setFormData] = useState({
        UserName: '',        
        Password: '' ,
               
  });

  return [formData, setFormData];
};